import "react-tooltip/dist/react-tooltip.css";
import "./LeafTooltip.scss";
import { Tooltip, TooltipRefProps } from "react-tooltip";
import { MutableRefObject, ReactElement, useEffect, useRef } from "react";

type Props = {
  content?: string;
  children?: ReactElement;
  id: string;
  icon: ReactElement;
  openOnClick?: boolean;
  backgroundColor?: "blue" | "default";
  position?: "top" | "bottom" | "left" | "right";
  tooltipRef?: MutableRefObject<TooltipRefProps | null>;
  ariaLabel?: string;
  disableDefaultHandleClick?: boolean;
};

const LeafTooltip = (props: Props) => {
  const {
    content,
    id,
    icon,
    children,
    openOnClick = false,
    backgroundColor = "default",
    position = "top",
    ariaLabel,
    disableDefaultHandleClick,
  } = props;
  const tooltipRef = useRef<TooltipRefProps>(null);

  const handleTooltipClick = () => {
    if (openOnClick === true && tooltipRef.current) {
      tooltipRef.current.open();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleTooltipClick();
    }
  };

  const accessibleLabel = ariaLabel || content;

  return (
    <div
      className="leaf-tooltip"
      data-testid={`leafTooltip`}
      role="button"
      tabIndex={disableDefaultHandleClick ? -1 : 0}
      onClick={disableDefaultHandleClick ? () => {} : handleTooltipClick}
      onKeyDown={disableDefaultHandleClick ? () => {} : handleKeyDown}
      aria-label={accessibleLabel}
    >
      <div data-tooltip-id={id} className="leaf-tooltip__trigger">
        {icon}
      </div>
      <Tooltip
        id={id}
        content={content}
        children={children}
        className={`leaf-tooltip__tooltip ${backgroundColor === "blue" ? "leaf-tooltip__tooltip--blue" : ""}`}
        disableStyleInjection={"core"}
        place={position}
        ref={props.tooltipRef || tooltipRef}
        delayShow={100}
        delayHide={100}
        positionStrategy="fixed"
        anchorSelect={`[data-tooltip-id="${id}"]`}
        openOnClick={props?.openOnClick}
      />
    </div>
  );
};

export default LeafTooltip;
